module.exports = __webpack_public_path__ + "static/media/icon_brain_network.424c62da.svg";